import React from "react";

const PurpleGradient = ({ className }) => {
  return (
    <svg
      width="1280"
      height="470"
      viewBox="0 0 1280 470"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <g filter="url(#filter0_f_6386_26243)">
        <rect
          width="762"
          height="578"
          rx="289"
          transform="matrix(1 0 0 -1 259 150)"
          fill="#9100FF"
          fillOpacity="0.32"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_6386_26243"
          x="-61"
          y="-748"
          width="1402"
          height="1218"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="160"
            result="effect1_foregroundBlur_6386_26243"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default PurpleGradient;
